export default "__VITE_ASSET__0507abe1__"